module.exports = __webpack_public_path__ + "static/media/Yannick - ZFE 61 - 5ème.f59bc338.mp3";